import { isNil } from "lodash";
import { type FC } from "react";

import { AssetValue } from "@ds/modules/settings/projects/components/formation/formation-asset-display-value";
import { CampaignValue } from "@ds/modules/settings/projects/components/formation/formation-campaign-display-value";
import { PlaylistValue } from "@ds/modules/settings/projects/components/formation/formation-playlist-card-row";
import {
  isAssetFormationProperty,
  isCampaignFormationProperty,
  isPlaylistFormationProperty,
} from "@ds/modules/settings/projects/utils/formation-guards";

import { UnassignedLabel } from "@ds/components/forms/labels/common";

import { formatPlayerValue } from "../../utils/player-roles";

/** A player's own value of a role field, shown read-only */
export const PlayerFormationValue: FC<{
  property: TemplateFormationProperty;
  value?: ExperienceDeviceFormationProperty["value"];
}> = ({ property, value }) => {
  if (isNil(value) || value === "") {
    return <UnassignedLabel text="Not set" />;
  }

  if (isPlaylistFormationProperty(property)) {
    return <PlaylistValue value={Number(value)} />;
  }

  if (isAssetFormationProperty(property)) {
    return <AssetValue value={Number(value)} />;
  }

  if (isCampaignFormationProperty(property)) {
    return <CampaignValue value={Number(value)} />;
  }

  return <>{formatPlayerValue(property, value)}</>;
};
